import React, { useRef, useState } from 'react';
import { useMediasize } from "../context/MediasizeContext";
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { ReactComponent as PlayMobIcon } from '../../assets/images/play-mob.svg';
import { ReactComponent as PauseMobIcon } from '../../assets/images/pause-mob.svg';
import { gaAudio, gaAudioProgress } from '../../utils/gatags';

import audif from "../../assets/audio/welcome.mp3"

import './MP3AudioPlayer.css'
// import Button from '../../components/Buttons/Play';

const MP3AudioPlayer = () => {



    const [fired10Event, setFired10Event] = useState(false);
    const [fired20Event, setFired20Event] = useState(false);
    const [fired30Event, setFired30Event] = useState(false);
    const [fired40Event, setFired40Event] = useState(false);
    const [fired50Event, setFired50Event] = useState(false);
    const [fired60Event, setFired60Event] = useState(false);
    const [fired70Event, setFired70Event] = useState(false);
    const [fired80Event, setFired80Event] = useState(false);
    const [fired90Event, setFired90Event] = useState(false);
    const [fired100Event, setFired100Event] = useState(false);

    let mediaSize = useMediasize();

        const onAudio = (_e, _audioaction) => {
            if ( _e.target.currentTime === 0 ) {
                setFired10Event(false);
                setFired20Event(false);
                setFired30Event(false);
                setFired40Event(false);
                setFired50Event(false);
                setFired60Event(false);
                setFired70Event(false);
                setFired80Event(false);
                setFired90Event(false);
                setFired100Event(false);
            }
            gaAudio(
                _audioaction,
                audif
              )
        }
        const audioProgress = (e) => {

            let duration = e.target.duration;
            let currenttime = e.target.currentTime;

            if ( !fired10Event ) {
                if ( Math.round((currenttime / duration) * 100) === 10 ) {
                    // console.log("------------ 10%");
                    setFired10Event(true);
                    gaAudioProgress(10, e.target.src);
                }
            }
            if ( !fired20Event ) {
                if ( Math.round((currenttime / duration) * 100) === 20 ) {
                    // console.log("------------ 20%");
                    setFired20Event(true);
                    gaAudioProgress(20, e.target.src);
                }
            }
            if ( !fired30Event ) {
                if ( Math.round((currenttime / duration) * 100) === 30 ) {
                    // console.log("------------ 30%");
                    setFired30Event(true);
                    gaAudioProgress(30, e.target.src);
                }
            }
            if ( !fired40Event ) {
                if ( Math.round((currenttime / duration) * 100) === 40 ) {
                    // console.log("------------ 40%");
                    setFired40Event(true);
                    gaAudioProgress(40, e.target.src);
                }
            }
            if ( !fired50Event ) {
                if ( Math.round((currenttime / duration) * 100) === 50 ) {
                    // console.log("------------ 50%");
                    setFired50Event(true);
                    gaAudioProgress(50, e.target.src);
                }
            }
            if ( !fired60Event ) {
                if ( Math.round((currenttime / duration) * 100) === 60 ) {
                    // console.log("------------ 60%");
                    setFired60Event(true);
                    gaAudioProgress(60, e.target.src);
                }
            }
            if ( !fired70Event ) {
                if ( Math.round((currenttime / duration) * 100) === 70 ) {
                    // console.log("------------ 70%");
                    setFired70Event(true);
                    gaAudioProgress(70, e.target.src);
                }
            }
            if ( !fired80Event ) {
                if ( Math.round((currenttime / duration) * 100) === 80 ) {
                    // console.log("------------ 80%");
                    setFired80Event(true);
                    gaAudioProgress(80, e.target.src);
                }
            }
            if ( !fired90Event ) {
                if ( Math.round((currenttime / duration) * 100) === 90 ) {
                    // console.log("------------ 90%");
                    setFired90Event(true);
                    gaAudioProgress(90, e.target.src);
                }
            }
            if ( !fired100Event ) {
                if ( Math.round((currenttime / duration) * 100) === 100 ) {
                    // console.log("------------ 100%");
                    setFired100Event(true);
                    gaAudioProgress(100, e.target.src);
                }
            }

            // gaAudio(
            //     _audioaction,
            //     audif
            //   )
        }

    return (
        <>
            <AudioPlayer
                src={audif}
                listenInterval={1000}
                onPlay={(e) => onAudio(e, "play")}
                onPause={(e) => onAudio(e, "pause")}
                // onListen={(e) => audioProgress(e)}
                onListen={audioProgress}
                layout={ mediaSize ? "stacked" : "stacked-reverse" }
                showJumpControls={mediaSize}
                showSkipControls={false}
                customAdditionalControls={ [] }
                customIcons={ mediaSize ? {
                    // play: <PlayIcon />
                  } : {
                    play: <PlayMobIcon />,
                    pause: <PauseMobIcon />
                  }}

                customProgressBarSection={
                    [
                        RHAP_UI.CURRENT_TIME,
                        RHAP_UI.PROGRESS_BAR,
                        RHAP_UI.DURATION,
                    ]
                }
                customVolumeControls={ mediaSize ? [RHAP_UI.VOLUME] : [] }
            />
            
        </>
    );
};


export default MP3AudioPlayer;